// Confessions Loading 
(function(){
  function revealConfessionsNow() {
    var wrap = document.getElementById('conf-loader-wrap');
    var overlay = document.getElementById('conf-loader-overlay');
    if (wrap) {
      wrap.classList.add('conf-loaded');
      wrap.removeAttribute('aria-busy');
    }
    if (overlay) {
      overlay.classList.add('hidden');
      setTimeout(function(){
        try { overlay.parentNode && overlay.parentNode.removeChild(overlay); } catch(e){}
      }, 360);
    }
  }
  async function waitAndReveal() {
    if (document.readyState !== 'complete') {
      await new Promise(r => window.addEventListener('load', r, { once: true }));
    }
    const TIMEOUT_MS = 8000;
    try {
      if (window.confessionsLikesReady && typeof window.confessionsLikesReady.then === 'function') {
        await Promise.race([
          window.confessionsLikesReady,
          new Promise((resolve) => setTimeout(resolve, TIMEOUT_MS))
        ]);
      } else {
        await new Promise((resolve) => setTimeout(resolve, 0));
      }
    } catch(e) {
    } finally {
      revealConfessionsNow();
    }
  }
  waitAndReveal();
})();

// Confessions Share 
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.conf-share');
  if (!btn) return;

  const url = btn.dataset.url;
  if (navigator.share) {
    try {
      await navigator.share({ url });
      return;
    } catch(e) {
    }
  }
});

// Confessions modal 
(function(){
  const BLOG_SLUG = '/blogs/confessions/';
  const INDEX_PATH = BLOG_SLUG;
  const modalWrap = document.getElementById('conf-modal-wrap');
  const modalTitle = document.getElementById('conf-modal-title');
  const modalMeta  = document.getElementById('conf-modal-meta');
  const modalBody  = document.getElementById('conf-modal-body');
  const modalClose = document.getElementById('conf-modal-close');

  const titleSelectors = ['.article-title','h1.article__title','article h1','.confession-title','h1','.blog-article__title'];
  const metaSelectors  = ['.article-meta','.confession-meta','.byline','time','.blog-article__meta'];
  const bodySelectors  = [
    '.article-content',
    '.confession-article',
    '.blog-article__content',
    '.rte',
    'article',
    '#MainContent',
    '.post-content',
    '.article-body'
  ];

  function parseQueryOpen() {
    try {
      const params = new URLSearchParams(location.search);
      const val = params.get('open');
      return val ? decodeURIComponent(val) : null;
    } catch(e) { return null; }
  }

  function parseReferrer() {
    try {
      const ref = document.referrer || '';
      if (!ref) return null;
      const u = new URL(ref, location.href);
      if (u.origin !== location.origin) return null;
      if (!u.pathname.startsWith(BLOG_SLUG)) return null;
      return u.pathname + (u.search||'') + (u.hash||'');
    } catch(e){ return null; }
  }

  function parseSessionStorageOpen() {
    try {
      const v = sessionStorage.getItem('openConfessionPath');
      return v ? v : null;
    } catch(e){ return null; }
  }
  function toAbsoluteUrl(pathOrUrl) {
    try {
      return new URL(pathOrUrl, location.origin).href;
    } catch(e){
      return null;
    }
  }
  function extractElementHtml(doc, selectors) {
    for (const sel of selectors) {
      const el = doc.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  async function fetchArticleData(url) {
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return null;
      const text = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      const titleEl = extractElementHtml(doc, titleSelectors);
      const metaEl  = extractElementHtml(doc, metaSelectors);
      const bodyEl  = extractElementHtml(doc, bodySelectors);

      const title = titleEl ? titleEl.innerHTML.trim() : '';
      const meta  = metaEl  ? metaEl.innerHTML.trim()  : '';
      let bodyHtml = '';

      if (bodyEl) {
        bodyHtml = bodyEl.innerHTML.trim();
      } else {
        const main = doc.querySelector('main') || doc.querySelector('body');
        bodyHtml = main ? main.innerHTML : '';
      }

      return { title, meta, body: bodyHtml };
    } catch(e){
      return null;
    }
  }

  function openModalWithContent(data, articleUrl) {
    if (!modalWrap) return;
    modalTitle.innerHTML = data.title || '';
    modalMeta.innerHTML  = data.meta  || '';
    modalBody.innerHTML  = data.body  || '';
    modalWrap.classList.add('open');
    modalWrap.setAttribute('aria-hidden','false');
    try {
      history.pushState({confModal:true, url: articleUrl}, '', articleUrl);
    } catch(e){}
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    try { modalClose && modalClose.focus(); } catch(e){}
  }

  function closeModalAndRestore(popState = true) {
    if (!modalWrap) return;
    modalWrap.classList.remove('open');
    modalWrap.setAttribute('aria-hidden','true');
    modalTitle.innerHTML = '';
    modalMeta.innerHTML = '';
    modalBody.innerHTML = '';
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (popState) {
      try { history.back(); } catch(e){}
    }
  }
  function highlightMatchingCard(articlePath) {
    if (!articlePath) return;
    const anchors = document.querySelectorAll('a[href]');
    const normalized = (p)=> {
      try { return new URL(p, location.origin).pathname.replace(/\/$/, ''); }
      catch(e){ return p.replace(/\/$/, ''); }
    };
    const targetPath = normalized(articlePath);
    for (const a of anchors) {
      try {
        const hrefPath = normalized(a.getAttribute('href'));
        if (hrefPath === targetPath) {
          const card = a.closest('.confession-item') || a.closest('.article-list-item') || a.parentElement;
          if (card) {
            card.classList.add('conf-highlight');
            card.scrollIntoView({behavior:'smooth', block:'center'});
            break;
          }
        }
      } catch(e){}
    }
  }
  (async function tryOpen() {
    let articlePath = null;
    articlePath = parseQueryOpen();
    if (!articlePath) articlePath = parseSessionStorageOpen();
    if (!articlePath) {
      const r = parseReferrer();
      if (r) articlePath = r;
    }

    if (!articlePath) return;
    const articleUrl = toAbsoluteUrl(articlePath);
    if (!articleUrl) return;
    const data = await fetchArticleData(articleUrl);
    if (!data) return;
    try { highlightMatchingCard(articlePath); } catch(e){}
    openModalWithContent(data, articleUrl);
  })();

  if (modalClose) modalClose.addEventListener('click', ()=> closeModalAndRestore(true));
  if (modalWrap) modalWrap.addEventListener('click', (e)=> {
    if (e.target === modalWrap) closeModalAndRestore(true);
  });

  window.addEventListener('popstate', function(e){
    const state = e.state;
    if (state && state.confModal && state.url) {
      (async ()=> {
        const data = await fetchArticleData(state.url);
        if (data) openModalWithContent(data, state.url);
      })();
    } else {
      if (modalWrap && modalWrap.classList.contains('open')) {
        closeModalAndRestore(false);
      }
    }
  });

})();

/* ================================
   GLOBAL SORT STATE
================================ */
let currentSort = 'latest';


/* ================================
   SORTING FUNCTION
================================ */
function sortConfessions() {
  const grid = document.querySelector('.confessions-grid');
  if (!grid) return;

  const items = Array.from(grid.querySelectorAll('.confession-item'));

  if (currentSort === 'latest') {
    items.sort((a, b) => {
      const dateA = a.querySelector('.confessions-date')?.dataset.date || '';
      const dateB = b.querySelector('.confessions-date')?.dataset.date || '';
      return new Date(dateB) - new Date(dateA);
    });

    items.forEach(item => grid.appendChild(item));
  }

  if (currentSort === 'popular') {
    items.sort((a, b) => {
      const likesA = parseInt(a.querySelector('.like-count')?.innerText || 0);
      const likesB = parseInt(b.querySelector('.like-count')?.innerText || 0);
      return likesB - likesA;
    });
    const topItems = items.slice(0, 6); // or 9

    topItems.reverse().forEach(item => {
      grid.insertBefore(item, grid.firstChild);
    });
  }
}

/* ================================
   FILTER BUTTON HANDLING
================================ */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.conf-filter-btn');
  if (!btn) return;

  currentSort = btn.dataset.sort;

  document.querySelectorAll('.conf-filter-btn').forEach(b => {
    b.setAttribute('aria-selected', 'false');
  });

  btn.setAttribute('aria-selected', 'true');

  sortConfessions();
});


/* ================================
   WAIT FOR LIKES → THEN SORT
================================ */
if (window.confessionsLikesReady) {
  window.confessionsLikesReady.then(() => {
    sortConfessions();
  });
}


/* ================================
   INFINITE SCROLL
================================ */
(function () {

  let isLoading = false;
  let nextUrl = null;

  const grid = document.querySelector('.confessions-grid');
  const trigger = document.getElementById('conf-load-trigger');
  const loader = document.getElementById('conf-loading');

  if (!grid || !trigger) return;

  nextUrl = trigger.dataset.nextUrl;

  const observer = new IntersectionObserver(async (entries) => {

    if (!entries[0].isIntersecting || isLoading || !nextUrl) return;

    isLoading = true;
    loader.style.display = 'block';

    try {
      const res = await fetch(nextUrl);
      const html = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newItems = doc.querySelectorAll('.confession-item');
      const newTrigger = doc.querySelector('#conf-load-trigger');

      newItems.forEach(item => grid.appendChild(item));
      if (newTrigger) {
        nextUrl = newTrigger.dataset.nextUrl;
      } else {
        nextUrl = null;
        observer.disconnect();
      }
      sortConfessions();

    } catch (err) {
      console.error('Infinite scroll error:', err);
    } finally {
      loader.style.display = 'none';
      isLoading = false;
    }

  }, {
    rootMargin: '200px'
  });

  observer.observe(trigger);

})();